module.exports = __webpack_public_path__ + "static/media/lightningGamesPlayed_5000_10000.c7d54263.png";